import React from 'react';
import { useTranslation } from 'react-i18next';
import { AccessDenied } from '@/presentation/components/common/AccessDenied';
import { useAuth } from '@/presentation/contexts/AuthContext';
import { PeriodOpsConfigForm } from '@/presentation/components/settings/PeriodOpsConfigForm';

export const PeriodSettingsPage: React.FC = () => {
  const { t } = useTranslation();
  const { canAdminister } = useAuth();

  if (!canAdminister) {
    return <AccessDenied />;
  }

  return (
    <div className="panel-page flex h-full min-w-0 flex-col overflow-hidden">
      <header className="shrink-0">
        <h1 className="panel-page-title">{t('pages.settings.tabPeriod')}</h1>
        <p className="panel-page-subtitle max-w-2xl leading-relaxed">
          {t('pages.settings.tabPeriodSubtitle')}
        </p>
      </header>
      <div className="mx-auto flex min-h-0 w-full max-w-3xl flex-1 flex-col">
        <PeriodOpsConfigForm canEdit={canAdminister} />
      </div>
    </div>
  );
};
